<div
  class="rich-checkbox-group"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-layout]="layout"
  [attr.data-disabled]="disabled"
  [attr.data-required]="required"
  [attr.data-error]="hasError"
  [attr.role]="'group'"
  [attr.aria-labelledby]="label ? computedId + '-label' : null"
>
  <!-- Group label -->
  <div *ngIf="label" class="group-label" [id]="computedId + '-label'">
    {{ label }}
    <span *ngIf="required" class="required-indicator" aria-hidden="true"
      >*</span
    >
  </div>

  <!-- Rich checkbox options -->
  <div class="options-container">
    <div
      *ngFor="let option of options; trackBy: trackByValue"
      class="rich-option"
      [attr.data-disabled]="disabled || option.disabled"
      [attr.data-selected]="isSelected(option.value)"
    >
      <!-- Checkbox with rich content -->
      <div class="rich-option-content">
        <umss-checkbox
          [label]="''"
          [id]="option.id"
          [size]="size"
          [checked]="isSelected(option.value)"
          [disabled]="
            disabled ||
            !!option.disabled ||
            (!canSelectMore && !isSelected(option.value))
          "
          [name]="name"
          [value]="option.value"
          (checkedChange)="onCheckboxChange(option, $event)"
        >
        </umss-checkbox>

        <!-- Rich text content -->
        <div
          class="rich-text-content"
          [class.disabled]="disabled || option.disabled"
          role="button"
          tabindex="0"
          (click)="
            !disabled &&
              !option.disabled &&
              onCheckboxChange(option, !isSelected(option.value))
          "
          (keydown.enter)="
            !disabled &&
              !option.disabled &&
              onCheckboxChange(option, !isSelected(option.value))
          "
          (keydown.space)="
            !disabled &&
              !option.disabled &&
              onCheckboxChange(option, !isSelected(option.value))
          "
        >
          <div class="primary-label">{{ option.label }}</div>
          <div *ngIf="option.secondaryText" class="secondary-text">
            {{ option.secondaryText }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Error message -->
  <div *ngIf="hasError && errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Selection count info -->
  <div *ngIf="maxSelections || minSelections" class="selection-info">
    <span class="selection-count">
      Selected: {{ selectedValues.length }}
      <span *ngIf="maxSelections"> / {{ maxSelections }}</span>
      <span *ngIf="minSelections && !maxSelections">
        (min: {{ minSelections }})</span
      >
    </span>
  </div>
</div>
